<template>
    <div class="container">
        <div class="col-lg-10 offset-lg-1">
            <template v-if="formInfo.SubmitSuccess">
                <!--
                <div class="alert alert-success">
                    <h2>Success!</h2>
                    <p>Your application has been submitted successfully.</p>
                </div>
                <h2>What's next?</h2>
                <p>We'll send you a confirmation email to the email address you provided when you created this account. You'll hear from someone in the Film Office in the next few days.</p>
                <p>In case you don't receive an email (check your junk folder!), here's your application info:</p>
                <h5>Permit number: {{formInfo.PermitId.trim() }}</h5>

                <p>Need to submit more forms?</p>

                <button
                    class="btn btn-outline-primary mb-3"
                    @click.prevent="newForm"
                >Start a new application</button>

                <p>
                    Please take a moment to
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLScMVUZ3t4TP5Lq6SBWHChTVsJ5As75Z1HUi8zNOHBoVKPEyUQ/viewform?usp=sf_link"
                        target="_blank"
                    >provide your feedback</a> about the application process. We read your responses and try our best to make this online application easier to use.
                </p>
                -->

                <div class="col-lg-10 offset-lg-1 d-block no-gutters pl-0">
                    <div class="alertMsg-success"> 
                        <p>Your appplication has been submitted</p>
                    </div>

                    <div class="mt-3">
                        Your application reference number is:  {{formInfo.PermitId.trim() }}
                        <br/><br/>
                        If you have any questions about your application, contact <a href="mailto:film.office@mississauga.ca">film.office@mississauga.ca</a>
                        <br/><br/>
                        <button @click="GoToDashboard" class="btn btn-sm btn-primary">Close and go to dashboard</button>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="alert alert-danger">
                    <h2>Sorry, something went wrong.</h2>
                    <p>There was an issue while submitting your application and we weren't able to submit it.</p>
                </div>
                <h2>What can you do?</h2>
                <p>
                    Please reach out to The Film Office in the Film Office at
                    <a
                        href="mailto:film.office@mississauga.ca"
                    >film.office@mississauga.ca</a> and attach this file containing your backed up form data:
                    <a
                        :href="JSONurl"
                        download="filmpermit-application.json"
                    >Recovered Form</a>.
                </p>
                <p>
                    Please take a moment to
                    <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLScMVUZ3t4TP5Lq6SBWHChTVsJ5As75Z1HUi8zNOHBoVKPEyUQ/viewform?usp=sf_link"
                        target="_blank"
                    >provide your feedback</a> about the application process. We read your responses and try our best to make this online application easier to use.
                </p>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplicationSubmitted",
    computed: {
        formInfo() {
            return this.$store.getters.submissionDetails;
        },
        JSONurl() {
            const contentType = "application/json";
            const dData = sessionStorage.getItem("saved_form");
            const blob = new Blob([dData], { type: contentType });
            return window.URL.createObjectURL(blob);
        }
    },
    methods: {
        downloadObjectAsJson(exportObj, exportName) {
            let dataStr =
                "data:text/json;charset=utf-8," +
                encodeURIComponent(
                    JSON.stringify(this.$store.getters.getFormData)
                );
            let downloadAnchorNode = document.createElement("a");
            downloadAnchorNode.setAttribute("href", dataStr);
            downloadAnchorNode.setAttribute("download", exportName + ".json");
            document.body.appendChild(downloadAnchorNode); // required for firefox
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        },
        newForm() {
            this.$store.dispatch("RESET_FORM").then(() => {
                this.$router.push("application");
            });
        },
        GoToDashboard(){
            this.$router.push("dashboard");
        }
    }
};
</script>

<style>
</style>
